import { createAsyncThunk } from '@reduxjs/toolkit';
import { DocumentsAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import {
  IUpdatePropertyDocumentStatusDTO,
  IUploadPropertyFilesDTO,
  TDeletePropertyFileDTO,
  TGetLegalDocumentsResponse,
  TGetLegalDocumentsDTO,
  TGetPropertyDocumentsDTO,
  TGetPropertyDocumentsResponse,
  TGetPropertyFilesDTO,
  TGetPropertyFilesResponse,
  TGetSelfDeclarationDTO,
  TGetSelfDeclarationResponse,
} from '@/models/documents.model';
import { formatApiError } from '@/utils';
import { DOCUMENTS_SLICE_NAME } from './models';

export const getPropertyDocuments = createAsyncThunk<
  TGetPropertyDocumentsResponse,
  TGetPropertyDocumentsDTO,
  { serializedErrorType: IApiError }
>(
  `${DOCUMENTS_SLICE_NAME}/getPropertyDocuments`,
  async (params) => {
    const response = await DocumentsAPI.getPropertyDocuments(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getPropertyFiles = createAsyncThunk<
  TGetPropertyFilesResponse,
  TGetPropertyFilesDTO,
  { serializedErrorType: IApiError }
>(
  `${DOCUMENTS_SLICE_NAME}/getPropertyFiles`,
  async (params) => {
    const response = await DocumentsAPI.getPropertyFiles(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getLegalDocuments = createAsyncThunk<
  TGetLegalDocumentsResponse,
  TGetLegalDocumentsDTO,
  { serializedErrorType: IApiError }
>(
  `${DOCUMENTS_SLICE_NAME}/getLegalDocuments`,
  async (params) => {
    const response = await DocumentsAPI.getLegalDocuments(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getSelfDeclaration = createAsyncThunk<
  TGetSelfDeclarationResponse,
  TGetSelfDeclarationDTO,
  { serializedErrorType: IApiError }
>(
  `${DOCUMENTS_SLICE_NAME}/getSelfDeclaration`,
  async (params) => {
    const response = await DocumentsAPI.getSelfDeclaration(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const uploadPropertyFiles = createAsyncThunk<
  TGetPropertyFilesResponse,
  IUploadPropertyFilesDTO,
  { serializedErrorType: IApiError }
>(
  `${DOCUMENTS_SLICE_NAME}/uploadPropertyFiles`,
  async (params) => {
    const response = await DocumentsAPI.uploadPropertyFiles(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deletePropertyFiles = createAsyncThunk<
  TGetPropertyFilesResponse,
  TDeletePropertyFileDTO,
  { serializedErrorType: IApiError }
>(
  `${DOCUMENTS_SLICE_NAME}/deletePropertyFiles`,
  async (data) => {
    const response = await DocumentsAPI.deletePropertyFiles(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updatePropertyDocumentStatus = createAsyncThunk<
  TGetPropertyDocumentsResponse,
  IUpdatePropertyDocumentStatusDTO,
  { serializedErrorType: IApiError }
>(
  `${DOCUMENTS_SLICE_NAME}/updatePropertyDocumentStatus`,
  async (params) => {
    const response = await DocumentsAPI.updatePropertyDocumentStatus(params);
    return response.data;
  },
  { serializeError: formatApiError },
);
